<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Colis postaux" />
            <ColisPostaux />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'
import ColisPostaux from '../Services/ColisPostaux'
import FooterComp from '../Layouts/FooterComp'

export default {
    name: 'ColisPostauxPage',
    components: {
        NavBar,
        PageTitle,
        ColisPostaux,
        FooterComp,
    }
}
</script>